import React from "react";
import { Table } from "@mui/material";
import { ParentProps } from "../types";

const classNameBase = "scd-table";

export default function CustomTable(props: ParentProps): React.ReactElement {
  return (
    <Table
      classes={{
        root: `${classNameBase}-root`,
      }}
    >
      {props.children}
    </Table>
  );
}
